export enum job_status {
    open = 'Abierto',
    closed = 'Cerrado',
    deleted = 'Deleted',
    default = 'Abierto'
}

export enum job_application_active {
    active = 'active',
    desisted = 'desisted',
}